"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.selectEntitiesByKeyAndJoin = void 0;

var _reReselect = _interopRequireDefault(require("re-reselect"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var mapArgsToCacheKey = function mapArgsToCacheKey(state, key, join) {
  return "".concat(key || '').concat(join.key || '').concat(join.value || '');
};

var selectEntitiesByKeyAndJoin = (0, _reReselect["default"])(function (state, key) {
  return state.data[key];
}, function (state, key, join) {
  return join.key;
}, function (state, key, join) {
  return join.value;
}, function (entities, key, value) {
  return (entities || []).filter(function (entity) {
    var entityValue = Array.isArray(key) ? key.reduce(function (subObj, subKey) {
      return (subObj || {})[subKey];
    }, entity) : entity[key];
    return entityValue === value;
  });
})(mapArgsToCacheKey);
exports.selectEntitiesByKeyAndJoin = selectEntitiesByKeyAndJoin;
var _default = selectEntitiesByKeyAndJoin;
exports["default"] = _default;